import { Controller } from "@hotwired/stimulus"

// Click-to-add recipient chips on the client email compose: appends a Team
// Contact's email to the To field unless it is already listed (case
// insensitive, comma separated, matching the server's parsing).
export default class extends Controller {
  static targets = ["input"]

  add(event) {
    const email = (event.currentTarget.dataset.email || "").trim()
    if (!email || !this.hasInputTarget) return
    const current = this.inputTarget.value.split(",").map(s => s.trim()).filter(Boolean)
    if (current.some(a => a.toLowerCase() === email.toLowerCase())) return
    current.push(email)
    this.inputTarget.value = current.join(", ")
  }
}
